<style scoped lang="scss">
@import "../../common/public";

img {
  @include w_h(px2rem(24.5px), px2rem(24.5px));
}

li {
  color: #B3BED1;
  width: (100%/4);
}

.cover {
  color: $mainColor;
}
</style>
<template>
  <div class="flex0">
    <ul class="flex footer flex-center bt">
      <router-link tag="li" :to="item.path" v-for="(item,index) in nav" :key="index" class="center flex0 lh11 pt10 pb10"
                   :class="{cover:curr===index}">
        <div class="icon">
          <img :src="curr===index?item.icon1:item.icon" alt="">
        </div>
        <div class="text fs10">{{ item.name }}</div>
      </router-link>
    </ul>
  </div>
</template>

<script>
const nav = [
  {
    name: '首页',
    path: '/index',
    icon: require('../../assets/index/bottom/首页@3x.png'),
    icon1: require('../../assets/index/bottom/首页-B@3x.png')
  },
  {
    name: '我的医生',
    path: '/my/doc/follow',
    icon: require('../../assets/index/bottom/我的医生@3x.png'),
    icon1: require('../../assets/index/bottom/我的医生-B@3x.png')
  },
  {
    name: '健康知识',
    path: '/article',
    icon: require('../../assets/index/bottom/医生发布@3x.png'),
    icon1: require('../../assets/index/bottom/医生发布-B@3x.png')
  },
  {
    name: '我的',
    path: '/Profile',
    icon: require('../../assets/index/bottom/我的@3x.png'),
    icon1: require('../../assets/index/bottom/我的-B@3x.png')
  }
];
export default {
  name: "index-bottom",
  props: {
    curr: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      nav
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/plugins/index/index-bottom.vue